<template>
    <div class="row">
        <div v-if="!isDataLoaded">{{translationHelper.getTranslation('camp_weve_loading_data')}}</div>
        <div v-if="isDataLoaded && hasError">{{translationHelper.getTranslation('camp_ErrorLoadingData')}}</div>
        <div v-if="isDataLoaded && !hasError">
            <router-view  :translationHelper="translationHelper" ></router-view>
        </div>
    </div>
</template>
<script>

    import {TranslationHelper} from "../../../_Base/Utils";
    import VDI from "../../../_Api/VDI";
    import {FetchApiMixin } from "../../_VueMixins/fetchApiMixin";

    export default{
        mixins:[FetchApiMixin]
        ,data() {
            return {
                translationHelper: {}
                ,isDataLoaded: false
                ,hasError:false
            }
        }
        , created() {
            this.translationHelper = new TranslationHelper(this.$parent.$data.translations);
            VDI.getUserStatus(null, this.getUserStatusSuccess,this.fetchApiFailure,()=>this.isDataLoaded=true);
        }
        ,methods: {
            getUserStatusSuccess(vdiStatusResponse) {
                if (!vdiStatusResponse || vdiStatusResponse.hasFailed ) {
                    this.hasError = true;
                }
                else if(vdiStatusResponse.status == "denied") { 
                    this.translationHelper = new TranslationHelper(vdiStatusResponse.translations);
                    this.$router.push({name: "VDINotAvailable"});
                }
                else if(vdiStatusResponse.status == "allowed") {
                    this.translationHelper = new TranslationHelper(vdiStatusResponse.translations);
                    this.$router.push({name: "VDIRegistrationForm"});
                }
                else if(vdiStatusResponse.status == "registered") {
                    this.translationHelper = new TranslationHelper(vdiStatusResponse.translations);
                    this.$router.push({name: "VDIUnregistrationForm"});
                }
            }
        }
    }
</script>

<style>
</style>
